module.exports = __webpack_public_path__ + "media/images/flags/me-34fab6888545c72cfc1e51322693667f.svg";